import React from "react"
import PropTypes from "prop-types"

import "./searchBar.scss"

const SearchBar = (props) => {
  let { classes, onMagGlassClick, label, ...inputProps } = props

  return (
    <div className="input-container" data-cy="search-bar">
      {label && <label>{label}</label>}
      <div className={`search-bar ${[classes && classes.join(" ")]}`}>
        <span
          className="glyphicon glyphicon-search"
          onClick={onMagGlassClick}
        />
        <input type="text" {...inputProps} />
      </div>
    </div>
  )
}

SearchBar.propTypes = {
  classes: PropTypes.arrayOf(PropTypes.string),
  onMagGlassClick: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  onKeyUp: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default SearchBar
